var render = function render(){var _vm=this,_c=_vm._self._c;return _c('footer',{staticClass:"footer"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-xs-12"},[_vm._v("\n\n      © EntwicklerHeld "+_vm._s(_vm.year)+". All rights reserved.\n      "),_c('a',{attrs:{"href":"#"}},[_vm._v("Terms of Service")]),_vm._v(" |\n      "),_c('a',{attrs:{"href":"#"}},[_vm._v("Privacy Policy")])])])])
}
var staticRenderFns = []

export { render, staticRenderFns }